import {FC, MouseEventHandler, useCallback, useMemo} from 'react';
import {SOCIAL_NETWORKS, WINDOW_OPEN_OPTIONS} from './constants';
import style from './style.module.scss';
import Icon from 'components/Icon';
import classNames from 'classnames';

interface IProps {
    externalUrl?: string;
    dataAutotestTarget?: string;
    onShare?: () => void;
}

export const ShareSocialNetworks: FC<IProps> = ({externalUrl, dataAutotestTarget, onShare}) => {
    const shareLink = useMemo(() => {
        if ('undefined' !== typeof window) {
            return window.location.href;
        }

        return '';
    }, []);

    const onSocNetClick = useCallback(
        (url: string): MouseEventHandler<HTMLAnchorElement> =>
            (e) => {
                e.preventDefault();
                window.open(externalUrl ? url + externalUrl : url + shareLink, '', WINDOW_OPEN_OPTIONS);
                onShare?.();
            },
        [externalUrl, onShare, shareLink],
    );

    return (
        <div className={classNames('share-social-networks', style.socialNetworks)}>
            {SOCIAL_NETWORKS.map(({icon, name, url}, index) => (
                <div
                    className={'js-share'}
                    data-autotest-target={'mobile-social'}
                    data-autotest-target-id={`mobile-social-${name}`}
                    data-share={name}
                    key={name}
                >
                    <a
                        className={classNames('soc-net-item', style.socNetItem)}
                        data-autotest-target={dataAutotestTarget}
                        data-autotest-target-id={`${dataAutotestTarget}${index + 1}`}
                        onClick={onSocNetClick(url)}
                    >
                        <Icon icon={icon} />
                    </a>
                </div>
            ))}
        </div>
    );
};
